import React from 'react';
import TodoList from './TodoList';
import './App.css';

const App = () => {
  return (
    <div className="App">
      <TodoList />
    </div>
  );
};

export default App;
